import styled from 'styled-components'
import { VerticalStyledScrollBar } from '~/styles'

export const MainHealthProcedureDetailsContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
`

export const Content = styled.div.attrs({
  scrollbarBackground: '#fff'
})`
  display: flex;
  flex: 1;
  flex-direction: column;
  height: 100%;
  overflow: auto;

  ${VerticalStyledScrollBar}
`
